import { render, staticRenderFns } from "./CourseBuilderTextNavigationForm.vue?vue&type=template&id=5d15601b&scoped=true&"
import script from "./CourseBuilderTextNavigationForm.vue?vue&type=script&lang=js&"
export * from "./CourseBuilderTextNavigationForm.vue?vue&type=script&lang=js&"
import style0 from "./CourseBuilderTextNavigationForm.vue?vue&type=style&index=0&id=5d15601b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d15601b",
  null
  
)

export default component.exports